module.exports = __webpack_public_path__ + "img/dummy2.118d8c6.jpg";